import {AxiosResponse} from 'axios';
import {
	ILastClosedShift,
	IRestaraunt,
	IRestTotal,
	IRevenueRestaurantsData,
} from '../../../entities/rKeeper';
import {api, API_URL} from '../../config';
import {IDateQuery} from '../../../types';
import {IRestTotalReq} from './types';

const BASE_PATH = 'shops';

export const getLastShiftRequest = (shop_id: number): Promise<AxiosResponse<ILastClosedShift>> => {
	return api.get<ILastClosedShift>(`${API_URL}/${BASE_PATH}/${shop_id}/last-closed-shift`);
};

export const getRevenueWaitersRequest = (
	shop_id: number,
	params: IDateQuery,
): Promise<AxiosResponse<IRevenueRestaurantsData>> => {
	return api.get<IRevenueRestaurantsData>(
		`${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/waiters`,
		{
			params: {
				...params,
			},
		},
	);
};

export const getRevenueRestaurantRequest = (
	shop_id: number,
	params: IDateQuery,
): Promise<AxiosResponse<IRevenueRestaurantsData>> => {
	return api.get<IRevenueRestaurantsData>(
		`${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/stations`,
		{
			params: {
				...params,
			},
		},
	);
};
export const getRestauransRequest = (shop_id: number): Promise<AxiosResponse<IRestaraunt[]>> => {
	return api.get<IRestaraunt[]>(`${API_URL}/${BASE_PATH}/${shop_id}/restaurants`);
};

export const getRestTotalRequest = (
	shop_id: number,
	params: IRestTotalReq,
): Promise<AxiosResponse<IRestTotal>> => {
	return api.get<IRestTotal>(
		`${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/totals`,
		{
			params: {
				...params,
			},
		},
	);
};
